export default "__VITE_ASSET__a61d47c8__"